// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import JobTitleTable from "../../DataTables/MasterData/JobTitle/JobTitleTable";

// Modals
import CreateJobTitleModal from "../../UiKits/Modal/MasterData/JobTitle/CreateJobTitle";

const JobTitleContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Job Titles" parent="Master Data / Employment" />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Master Data Management</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage job titles options used throughout the HRIS for
                  employee and applicant personal information.
                </P>
                <CreateJobTitleModal />
                <JobTitleTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default JobTitleContainer;
